<template>
<div class="visual-process">
    <h3>{{ produktnaam }}verzekering</h3>
		<div class="grid-container">

			<step1schademelden-component
					:ctx="ctx"
					:schademeldenurl="schademeldenurl"
			></step1schademelden-component>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-archive clean"></p>
				</div>
				<h4>In behandeling</h4>
				<p>Wij nemen uw schademelding binnen 48 uur in behandeling en dragen het dossier over aan de ongevallenverzekeraar.</p>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-user clean"></p>
				</div>
				<h4>Beoordeling</h4>
				<p>Vaststelling mate van letsel.</p>
				<a href="#" data-toggle="modal" data-target="#beoordelingmodal" >Lees meer</a>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-check clean"></p>
				</div>
				<h4>Afgehandeld</h4>
				<p>Wij hebben uw dossier gesloten.</p>
			</div>

		</div>

	
		<!-- Modal beoordeling -->
			<div class="modal fade" id="beoordelingmodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">Beoordeling</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>De ongevallenverzekeraar wacht tot uw medische behandeling is afgerond. Hierna wordt bepaald of er sprake is van blijvend letsel. Is er sprake van blijvend letsel dan schakelt de ongevallenverzekeraar een medisch adviseur in die de mate van invaliditeit gaat bepalen.
Aan de hand van het vastgestelde percentage blijvende invaliditeit volgt een uitkering.</p>
					  <br />
					<p>Is er geen blijvend letsel, dan wordt het dossier gesloten.</p>
			        	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->





</div> 
</template>

<script>

    import step1SchadeMelden from './step1schademelden.vue'

export default {
  name: 'ongevallen-component',
    components: {
        'step1schademelden-component': step1SchadeMelden
    },
  props: {	  
	  ctx: String,
      produktnaam: String,
      schademeldenurl: String,
  },
  data: function () {
    return {    	
     }
  } 
  
}

</script>




// WEBPACK FOOTER //
// ongevallen.vue?49f91f36